
const filterData = (reportData,status,type) =>{
    let data;
    if(type){
        data = reportData.filter(data => data.grievanceType == type && data.grievanceStatus == status)
    }else {
        data = reportData.filter(data => data.grievanceStatus == status)
    }
    return data;
}

export const countOpen = (reportData,type) =>{
    let status = 1;
    return filterData(reportData,status,type);
}

export const countInProgress = (reportData,type) =>{
    let status = 2;
    return filterData(reportData,status,type);
}

export const countClosed = (reportData,type) =>{
    let status = 3;
    return filterData(reportData,status,type);
}

export const countReopened = (reportData,type) =>{
    let status = 4;
    return filterData(reportData,status,type);
}

export const countSelfCanceled = (reportData,type) =>{
    let status = 5;
    return filterData(reportData,status,type);
}

export const countOnHold = (reportData,type) =>{
    let status = 6;
    return filterData(reportData,status,type);
}


export const countTotal = (reportData,type) =>{
    let data;
    if(type){
        data = reportData.filter(data => data.grievanceType == type)
    } else {
        data = reportData;
    }
    return data;
}